import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const putJobCancel = async ({ jobId, reasonId, description, notifications, charges }: JsonDataItem) => {
  const { data } = await baseQuery('job-cancel', {
    type: 'PUT',
    body: {
      job_id: jobId,
      cancellation_reason_id: reasonId,
      cancellation_reason: description,
      notifications,
      cancellation_charges: charges,
    },
  });

  return data;
};
